import WithDirection from '@app/settings/withDirection';
import { Pagination } from 'antd';
import AntPagination from './styles/pagination.style';

const Paginations = AntPagination(Pagination);

export const isoPagination = WithDirection(Paginations);
